import React from "react";
import { TableRow, TableCell, IconButton } from "@material-ui/core";
import { DeleteOutline, EditOutlined } from "@material-ui/icons";
import PropTypes from "prop-types";

import { connect } from "react-redux";
const CountriesTableRow = ({
  handleEditItem,
  handleDeleteItem,
  index,
  name,
  user: { permissions, is_super_admin },
}) => (
  <TableRow>
    <TableCell align="center">{index}</TableCell>
    <TableCell align="center">{name.ar}</TableCell>
    <TableCell align="center">
      {is_super_admin || permissions.includes(20) ? (
        <IconButton aria-label="edit" onClick={handleEditItem}>
          <EditOutlined />
        </IconButton>
      ) : (
        ""
      )}
      {is_super_admin || permissions.includes(8) ? (
        <IconButton aria-label="delete" onClick={handleDeleteItem}>
          <DeleteOutline color="error" />
        </IconButton>
      ) : (
        ""
      )}
    </TableCell>
  </TableRow>
);

CountriesTableRow.propTypes = {
  handleEditItem: PropTypes.func.isRequired,
  handleDeleteItem: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.object.isRequired,
};

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(CountriesTableRow);
